import styled from 'styled-components/macro';

const ShapeImage = styled.img`
  width: 50%;
`;

export default ShapeImage;
